
const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card p-8 md:p-12 rounded-3xl">
            <h1 className="text-4xl md:text-5xl font-lora font-bold gradient-text mb-8">
              Politika zasebnosti
            </h1>
            
            <div className="prose prose-invert prose-lg max-w-none">
              <p className="text-white/80 text-lg leading-relaxed mb-8">
                Zadnja posodobitev: 1. januar 2024
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">1. Uvod</h2>
                <p className="text-white/80 leading-relaxed mb-4">
                  Allmaverse, s.p., z naslovom Žički prehod 4, 2000 Maribor (v nadaljevanju "mi", "nas", "naš" ali "Allmaverse"), 
                  spoštuje vašo zasebnost in je zavezana k zaščiti vaših osebnih podatkov.
                </p>
                <p className="text-white/80 leading-relaxed">
                  Ta politika zasebnosti pojasnjuje, kako zbiramo, uporabljamo, shranjujemo in ščitimo vaše osebne podatke 
                  v skladu z Uredbo (EU) 2016/679 (Splošna uredba o varstvu podatkov - GDPR).
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">2. Upravljavec podatkov</h2>
                <div className="text-white/80 leading-relaxed space-y-2">
                  <p><strong>Ime:</strong> Alma Lovrenčič, s.p.</p>
                  <p><strong>Naslov:</strong> Žički prehod 4, 2000 Maribor, Slovenija</p>
                  <p><strong>E-pošta:</strong> alma.lovrencic@gmail.com</p>
                  <p><strong>Telefon:</strong> +386 51 479 667</p>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">3. Katere podatke zbiramo</h2>
                <div className="text-white/80 leading-relaxed">
                  <h3 className="text-xl font-medium text-white mb-3">3.1 Podatki, ki jih posredujete prostovoljno:</h3>
                  <ul className="list-disc pl-6 space-y-2 mb-4">
                    <li>Ime in priimek</li>
                    <li>E-poštni naslov</li>
                    <li>Telefonska številka</li>
                    <li>Sporočila in povpraševanja</li>
                    <li>Podatki o naročenih storitvah</li>
                  </ul>
                  
                  <h3 className="text-xl font-medium text-white mb-3">3.2 Podatki, ki se zbirajo samodejno:</h3>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>IP naslov</li>
                    <li>Podatki o brskalniku in napravi</li>
                    <li>Čas obiska spletne strani</li>
                    <li>Podatki o navigaciji po strani</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">4. Namen obdelave podatkov</h2>
                <div className="text-white/80 leading-relaxed">
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Komunikacija z vami in odgovarjanje na povpraševanja</li>
                    <li>Izvajanje naročenih storitev</li>
                    <li>Pošiljanje e-novic (z vašo privolitvijo)</li>
                    <li>Izboljšanje spletne strani in storitev</li>
                    <li>Izpolnjevanje zakonskih obveznosti</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">5. Pravna podlaga za obdelavo</h2>
                <div className="text-white/80 leading-relaxed">
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Privolitev (za e-novice in neobvezno komunikacijo)</li>
                    <li>Izvajanje pogodbe (za naročene storitve)</li>
                    <li>Upravičeni interesi (za izboljšanje storitev)</li>
                    <li>Zakonske obveznosti (za davčno dokumentacijo)</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">6. Vaše pravice</h2>
                <div className="text-white/80 leading-relaxed">
                  <p className="mb-3">V skladu z GDPR imate naslednje pravice:</p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Pravica do dostopa do podatkov</li>
                    <li>Pravica do popravka podatkov</li>
                    <li>Pravica do izbrisanja podatkov</li>
                    <li>Pravica do omejitve obdelave</li>
                    <li>Pravica do prenosljivosti podatkov</li>
                    <li>Pravica do ugovora</li>
                    <li>Pravica do umika privolitve</li>
                  </ul>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">7. Piškotki</h2>
                <p className="text-white/80 leading-relaxed">
                  Naša spletna stran uporablja piškotke za izboljšanje uporabniške izkušnje. 
                  Več informacij o piškotkih najdete v naši 
                  <a href="/pravni-dokumenti/politika-piskotkov" className="text-purple-300 hover:text-purple-200 underline ml-1">
                    politiki piškotkov
                  </a>.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">8. Kontakt</h2>
                <p className="text-white/80 leading-relaxed">
                  Za vprašanja v zvezi z varovanjem osebnih podatkov nas kontaktirajte na:
                </p>
                <div className="mt-4 p-4 glass-card rounded-xl">
                  <p className="text-white/90">
                    <strong>E-pošta:</strong> alma.lovrencic@gmail.com<br />
                    <strong>Telefon:</strong> +386 51 479 667
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-lora font-semibold text-white mb-4">9. Spremembe politike</h2>
                <p className="text-white/80 leading-relaxed">
                  Pridržujemo si pravico do spremembe te politike zasebnosti. O vseh pomembnejših 
                  spremembah vas bomo obvestili preko naše spletne strani ali e-pošte.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;